function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackegesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    xmlns: "http://www.w3.org/2000/svg",
    height: 83,
    id: "screenshot-309ab5b4-45ef-804e-8007-b2c56a13fc92",
    viewBox: "2527 3329 86 83",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a13fc92",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-8476-Layer_2",
    viewBox: "0 0 73.14 68.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-8476-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.94,12.81l-1.65-.9-.9-1.65c-.14-.25-.54-.25-.68,0l-.9,1.65-1.65.9c-.12.07-.2.2-.2.34s.08.27.2.34l1.65.9.9,1.65c.07.12.2.2.34.2s.27-.08.34-.2l.9-1.65,1.65-.9c.12-.07.2-.2.2-.34,0-.14-.08-.27-.2-.34Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.58,2.74l-1.65-.9-.9-1.65c-.14-.25-.54-.25-.68,0l-.9,1.65-1.65.9c-.12.07-.2.2-.2.34s.08.27.2.34l1.65.9.9,1.65c.07.12.2.2.34.2s.27-.08.34-.2l.9-1.65,1.65-.9c.12-.07.2-.2.2-.34,0-.14-.08-.27-.2-.34Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96,33.36l-2.47-1.35-1.35-2.47c-.2-.37-.81-.37-1.02,0l-1.35,2.47-2.47,1.35c-.19.1-.3.3-.3.51s.12.41.3.51l2.47,1.35,1.35,2.47c.1.19.3.3.51.3s.41-.12.51-.3l1.35-2.47,2.47-1.35c.19-.1.3-.3.3-.51,0-.21-.12-.41-.3-.51Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,11.71c0-.31-.25-.57-.57-.57h-.33l.24-.27c.22-.22.22-.6,0-.82-.22-.22-.61-.23-.84,0l-.27.23v-.33c0-.31-.25-.57-.57-.57s-.57.25-.57.57v.33l-.2-.24c-.22-.22-.57-.22-.79,0-.22.22-.21.61,0,.83l.24.27h-.33c-.31,0-.57.25-.57.57s.25.57.57.57h.33l-.24.21c-.22.22-.22.57,0,.79.11.11.26.16.4.16s.26-.06.37-.17l.2-.24v.33c0,.31.25.57.57.57s.57-.25.57-.57v-.33l.27.24c.11.11.27.17.42.17s.3-.06.41-.17c.22-.22.23-.55,0-.77l-.23-.21h.33c.31,0,.57-.25.57-.57Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.31,18.73c0-.4-.32-.72-.72-.72h-.42l.3-.34c.28-.28.28-.76,0-1.04-.28-.28-.78-.29-1.06,0l-.34.29v-.42c0-.4-.32-.72-.72-.72s-.72.32-.72.72v.42l-.26-.3c-.28-.28-.72-.28-1,0-.28.28-.27.78.01,1.06l.31.34h-.42c-.4,0-.72.32-.72.72s.32.72.72.72h.42l-.3.26c-.28.28-.28.72,0,1,.14.14.32.2.51.2s.33-.08.47-.22l.26-.3v.42c0,.4.32.72.72.72s.72-.32.72-.72v-.42l.34.3c.14.14.34.21.53.21s.38-.07.52-.21c.28-.28.29-.7,0-.98l-.29-.26h.42c.4,0,.72-.32.72-.72Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.45 47.67 42.41 67.15 24.2 54.94 23.31 37.32",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.46 47.4 42.41 67.15 60.48 54.94 61.37 37.07",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.52 48.59 51.92 52.14 68.82 39.99 61.42 36.29",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.49 48.65 33.09 52.2 16.19 40.05 23.59 36.34",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.52 23.98 34.42 21.65 17.03 32.29 23.29 36.23",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "60.92 36.12 67.84 32.19 50.93 21.43 42.67 23.93",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.52 48.59 23.61 36.29 42.52 23.98 61.42 36.29 42.52 48.59",
    style: {
      fill: "#8d6a9c",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.52,
    y1: 23.98,
    x2: 42.52,
    y2: 48.06,
    style: {
      fill: "none",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.67 24.6 42.52 48.59 61.42 36.29 42.67 24.6",
    style: {
      strokeWidth: 0,
      fill: "#480b60"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-8476-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.94,12.81l-1.65-.9-.9-1.65c-.14-.25-.54-.25-.68,0l-.9,1.65-1.65.9c-.12.07-.2.2-.2.34s.08.27.2.34l1.65.9.9,1.65c.07.12.2.2.34.2s.27-.08.34-.2l.9-1.65,1.65-.9c.12-.07.2-.2.2-.34,0-.14-.08-.27-.2-.34Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.58,2.74l-1.65-.9-.9-1.65c-.14-.25-.54-.25-.68,0l-.9,1.65-1.65.9c-.12.07-.2.2-.2.34s.08.27.2.34l1.65.9.9,1.65c.07.12.2.2.34.2s.27-.08.34-.2l.9-1.65,1.65-.9c.12-.07.2-.2.2-.34,0-.14-.08-.27-.2-.34Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96,33.36l-2.47-1.35-1.35-2.47c-.2-.37-.81-.37-1.02,0l-1.35,2.47-2.47,1.35c-.19.1-.3.3-.3.51s.12.41.3.51l2.47,1.35,1.35,2.47c.1.19.3.3.51.3s.41-.12.51-.3l1.35-2.47,2.47-1.35c.19-.1.3-.3.3-.51,0-.21-.12-.41-.3-.51Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,11.71c0-.31-.25-.57-.57-.57h-.33l.24-.27c.22-.22.22-.6,0-.82-.22-.22-.61-.23-.84,0l-.27.23v-.33c0-.31-.25-.57-.57-.57s-.57.25-.57.57v.33l-.2-.24c-.22-.22-.57-.22-.79,0-.22.22-.21.61,0,.83l.24.27h-.33c-.31,0-.57.25-.57.57s.25.57.57.57h.33l-.24.21c-.22.22-.22.57,0,.79.11.11.26.16.4.16s.26-.06.37-.17l.2-.24v.33c0,.31.25.57.57.57s.57-.25.57-.57v-.33l.27.24c.11.11.27.17.42.17s.3-.06.41-.17c.22-.22.23-.55,0-.77l-.23-.21h.33c.31,0,.57-.25.57-.57Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.31,18.73c0-.4-.32-.72-.72-.72h-.42l.3-.34c.28-.28.28-.76,0-1.04-.28-.28-.78-.29-1.06,0l-.34.29v-.42c0-.4-.32-.72-.72-.72s-.72.32-.72.72v.42l-.26-.3c-.28-.28-.72-.28-1,0-.28.28-.27.78.01,1.06l.31.34h-.42c-.4,0-.72.32-.72.72s.32.72.72.72h.42l-.3.26c-.28.28-.28.72,0,1,.14.14.32.2.51.2s.33-.08.47-.22l.26-.3v.42c0,.4.32.72.72.72s.72-.32.72-.72v-.42l.34.3c.14.14.34.21.53.21s.38-.07.52-.21c.28-.28.29-.7,0-.98l-.29-.26h.42c.4,0,.72-.32.72-.72Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.45 47.67 42.41 67.15 24.2 54.94 23.31 37.32",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.46 47.4 42.41 67.15 60.48 54.94 61.37 37.07",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.52 48.59 51.92 52.14 68.82 39.99 61.42 36.29",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.49 48.65 33.09 52.2 16.19 40.05 23.59 36.34",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.52 23.98 34.42 21.65 17.03 32.29 23.29 36.23",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "60.92 36.12 67.84 32.19 50.93 21.43 42.67 23.93",
    style: {
      fill: "#794c8a",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.52 48.59 23.61 36.29 42.52 23.98 61.42 36.29 42.52 48.59",
    style: {
      fill: "#8d6a9c",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.52,
    y1: 23.98,
    x2: 42.52,
    y2: 48.06,
    style: {
      fill: "none",
      stroke: "#480b60",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.67 24.6 42.52 48.59 61.42 36.29 42.67 24.6",
    style: {
      strokeWidth: 0,
      fill: "#480b60"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15765c",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a15765c"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 2527,
    y: 3329,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 86,
    height: 83,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15765d"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15765e",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15a7a7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a15a7a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2612.764404296875,3344.615478515625L2610.82470703125,3343.517822265625L2609.76611328125,3341.506103515625C2609.601806640625,3341.20166015625,2609.132080078125,3341.20166015625,2608.96630859375,3341.506103515625L2607.908203125,3343.517822265625L2605.96875,3344.615478515625C2605.82763671875,3344.700927734375,2605.73291015625,3344.858642578125,2605.73291015625,3345.02978515625C2605.73291015625,3345.20068359375,2605.82763671875,3345.35888671875,2605.96875,3345.444091796875L2607.908203125,3346.541015625L2608.96630859375,3348.552001953125C2609.049560546875,3348.69873046875,2609.2021484375,3348.79638671875,2609.3671875,3348.79638671875C2609.531005859375,3348.79638671875,2609.68505859375,3348.69873046875,2609.76611328125,3348.552001953125L2610.82470703125,3346.541015625L2612.764404296875,3345.444091796875C2612.90625,3345.35888671875,2613,3345.20068359375,2613,3345.02978515625C2613,3344.858642578125,2612.90625,3344.700927734375,2612.764404296875,3344.615478515625Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15a7a8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a15a7a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2571.187255859375,3332.340087890625L2569.247314453125,3331.2431640625L2568.189697265625,3329.230712890625C2568.02392578125,3328.9267578125,2567.5537109375,3328.9267578125,2567.389892578125,3329.230712890625L2566.331787109375,3331.2431640625L2564.3916015625,3332.340087890625C2564.250244140625,3332.42578125,2564.15576171875,3332.584228515625,2564.15576171875,3332.7548828125C2564.15576171875,3332.925048828125,2564.250244140625,3333.083251953125,2564.3916015625,3333.168212890625L2566.331787109375,3334.26611328125L2567.389892578125,3336.277099609375C2567.47216796875,3336.423828125,2567.625,3336.520751953125,2567.788818359375,3336.520751953125C2567.953857421875,3336.520751953125,2568.107177734375,3336.423828125,2568.189697265625,3336.277099609375L2569.247314453125,3334.26611328125L2571.187255859375,3333.168212890625C2571.328857421875,3333.083251953125,2571.423095703125,3332.925048828125,2571.423095703125,3332.7548828125C2571.423095703125,3332.584228515625,2571.328857421875,3332.42578125,2571.187255859375,3332.340087890625Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15ec12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a15ec12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2537.535400390625,3369.665771484375L2534.631103515625,3368.02001953125L2533.043701171875,3365.008544921875C2532.80859375,3364.55810546875,2532.091796875,3364.55810546875,2531.8447265625,3365.008544921875L2530.2568359375,3368.02001953125L2527.353271484375,3369.665771484375C2527.129150390625,3369.787353515625,2527,3370.030517578125,2527,3370.287109375C2527,3370.54296875,2527.140869140625,3370.7861328125,2527.353271484375,3370.90771484375L2530.2568359375,3372.553955078125L2531.8447265625,3375.564697265625C2531.96240234375,3375.796142578125,2532.1962890625,3375.9306640625,2532.444580078125,3375.9306640625C2532.691162109375,3375.9306640625,2532.92626953125,3375.7841796875,2533.043701171875,3375.564697265625L2534.631103515625,3372.553955078125L2537.535400390625,3370.90771484375C2537.759521484375,3370.7861328125,2537.888671875,3370.54296875,2537.888671875,3370.287109375C2537.888671875,3370.030517578125,2537.746826171875,3369.787353515625,2537.535400390625,3369.665771484375Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a15ec13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a15ec13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2584.8857421875,3343.2734375C2584.8857421875,3342.896240234375,2584.59228515625,3342.5791015625,2584.215576171875,3342.5791015625L2583.826904296875,3342.5791015625L2584.10986328125,3342.25C2584.36865234375,3341.981689453125,2584.36865234375,3341.51953125,2584.10986328125,3341.251708984375C2583.850830078125,3340.983154296875,2583.39306640625,3340.970458984375,2583.1220703125,3341.251708984375L2582.80517578125,3341.53076171875L2582.80517578125,3341.1279296875C2582.80517578125,3340.75048828125,2582.51123046875,3340.433349609375,2582.134521484375,3340.433349609375C2581.75830078125,3340.433349609375,2581.46435546875,3340.73876953125,2581.46435546875,3341.1279296875L2581.46435546875,3341.53076171875L2581.229736328125,3341.23876953125C2580.97021484375,3340.970458984375,2580.55859375,3340.970458984375,2580.299560546875,3341.23876953125C2580.04150390625,3341.506103515625,2580.053466796875,3341.981689453125,2580.299560546875,3342.25L2580.58251953125,3342.5791015625L2580.1943359375,3342.5791015625C2579.829833984375,3342.5791015625,2579.52392578125,3342.884033203125,2579.52392578125,3343.2734375C2579.52392578125,3343.664306640625,2579.81787109375,3343.96875,2580.1943359375,3343.96875L2580.58251953125,3343.96875L2580.299560546875,3344.225341796875C2580.04150390625,3344.493896484375,2580.04150390625,3344.919921875,2580.299560546875,3345.188232421875C2580.4296875,3345.322265625,2580.60546875,3345.383056640625,2580.7705078125,3345.383056640625C2580.935302734375,3345.383056640625,2581.076171875,3345.309814453125,2581.205322265625,3345.17578125L2581.4404296875,3344.88330078125L2581.4404296875,3345.285888671875C2581.4404296875,3345.663330078125,2581.734375,3345.979736328125,2582.111572265625,3345.979736328125C2582.4873046875,3345.979736328125,2582.78125,3345.67578125,2582.78125,3345.285888671875L2582.78125,3344.88330078125L2583.09912109375,3345.17578125C2583.22802734375,3345.309814453125,2583.416015625,3345.383056640625,2583.59228515625,3345.383056640625C2583.768798828125,3345.383056640625,2583.944580078125,3345.309814453125,2584.0751953125,3345.17578125C2584.3330078125,3344.907470703125,2584.344970703125,3344.505126953125,2584.0751953125,3344.237060546875L2583.803955078125,3343.98095703125L2584.192138671875,3343.98095703125C2584.556884765625,3343.98095703125,2584.86279296875,3343.677001953125,2584.86279296875,3343.286376953125Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a1614d9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a1614d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2554.408203125,3351.8310546875C2554.408203125,3351.343505859375,2554.0322265625,3350.953369140625,2553.5625,3350.953369140625L2553.067626953125,3350.953369140625L2553.4208984375,3350.5390625C2553.74951171875,3350.1982421875,2553.74951171875,3349.61279296875,2553.4208984375,3349.271484375C2553.091552734375,3348.930419921875,2552.503662109375,3348.91796875,2552.17431640625,3349.271484375L2551.77490234375,3349.625L2551.77490234375,3349.114013671875C2551.77490234375,3348.62548828125,2551.39794921875,3348.23486328125,2550.927734375,3348.23486328125C2550.457275390625,3348.23486328125,2550.081298828125,3348.62548828125,2550.081298828125,3349.114013671875L2550.081298828125,3349.625L2549.776123046875,3349.26025390625C2549.446044921875,3348.91796875,2548.929443359375,3348.91796875,2548.600341796875,3349.26025390625C2548.271484375,3349.600341796875,2548.2822265625,3350.2099609375,2548.611572265625,3350.551513671875L2548.976318359375,3350.9658203125L2548.482177734375,3350.9658203125C2548.012451171875,3350.9658203125,2547.635986328125,3351.35546875,2547.635986328125,3351.84326171875C2547.635986328125,3352.330810546875,2548.012451171875,3352.721435546875,2548.482177734375,3352.721435546875L2548.976318359375,3352.721435546875L2548.62353515625,3353.0380859375C2548.294677734375,3353.379638671875,2548.294677734375,3353.91650390625,2548.62353515625,3354.25634765625C2548.787841796875,3354.428466796875,2549.000244140625,3354.500732421875,2549.223388671875,3354.500732421875C2549.446044921875,3354.500732421875,2549.6103515625,3354.4033203125,2549.776123046875,3354.23291015625L2550.081298828125,3353.866943359375L2550.081298828125,3354.379150390625C2550.081298828125,3354.866455078125,2550.457275390625,3355.257080078125,2550.927734375,3355.257080078125C2551.39794921875,3355.257080078125,2551.77490234375,3354.866455078125,2551.77490234375,3354.379150390625L2551.77490234375,3353.866943359375L2552.17431640625,3354.23291015625C2552.339111328125,3354.4033203125,2552.574462890625,3354.4892578125,2552.797607421875,3354.4892578125C2553.020751953125,3354.4892578125,2553.24462890625,3354.4033203125,2553.409423828125,3354.23291015625C2553.73828125,3353.8916015625,2553.74951171875,3353.379638671875,2553.409423828125,3353.0380859375L2553.067626953125,3352.721435546875L2553.5625,3352.721435546875C2554.0322265625,3352.721435546875,2554.408203125,3352.330810546875,2554.408203125,3351.84326171875Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a1614da"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a1614da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.914306640625,3387.1083984375L2576.8662109375,3410.85400390625L2555.454345703125,3395.97021484375L2554.408203125,3374.491943359375",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd2c963-309ab5b4-45ef-804e-8007-b2c56a1614da",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.914306640625,3387.1083984375L2576.8662109375,3410.85400390625L2555.454345703125,3395.97021484375L2554.408203125,3374.491943359375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a167ed7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a167ed7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.925537109375,3386.779052734375L2576.8662109375,3410.85400390625L2598.1142578125,3395.97021484375L2599.1611328125,3374.1875",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd2c964-309ab5b4-45ef-804e-8007-b2c56a167ed7",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.925537109375,3386.779052734375L2576.8662109375,3410.85400390625L2598.1142578125,3395.97021484375L2599.1611328125,3374.1875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a167ed8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a167ed8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3388.230224609375L2588.048828125,3392.55712890625L2607.92138671875,3377.74658203125L2599.21923828125,3373.23681640625",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd2c965-309ab5b4-45ef-804e-8007-b2c56a167ed8",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3388.230224609375L2588.048828125,3392.55712890625L2607.92138671875,3377.74658203125L2599.21923828125,3373.23681640625",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a167ed9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a167ed9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.961181640625,3388.303955078125L2565.908203125,3392.63037109375L2546.0361328125,3377.81982421875L2554.73828125,3373.297607421875",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd2c966-309ab5b4-45ef-804e-8007-b2c56a167ed9",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.961181640625,3388.303955078125L2565.908203125,3392.63037109375L2546.0361328125,3377.81982421875L2554.73828125,3373.297607421875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a167eda"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a167eda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3358.23046875L2567.47216796875,3355.390625L2547.023681640625,3368.35986328125L2554.385498046875,3373.16357421875",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd30c94-309ab5b4-45ef-804e-8007-b2c56a167eda",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3358.23046875L2567.47216796875,3355.390625L2547.023681640625,3368.35986328125L2554.385498046875,3373.16357421875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a167edb"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a167edb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2598.63134765625,3373.029541015625L2606.767822265625,3368.23828125L2586.884521484375,3355.122314453125L2577.17236328125,3358.169677734375",
    style: {
      strokeMiterlimit: 10,
      fill: "#794c8a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd30c95-309ab5b4-45ef-804e-8007-b2c56a167edb",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2598.63134765625,3373.029541015625L2606.767822265625,3368.23828125L2586.884521484375,3355.122314453125L2577.17236328125,3358.169677734375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a1698a4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a1698a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3388.230224609375L2554.761474609375,3373.23681640625L2576.996337890625,3358.23046875L2599.21923828125,3373.23681640625L2576.996337890625,3388.230224609375Z",
    style: {
      strokeMiterlimit: 10,
      fill: "#8d6a9c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd30c96-309ab5b4-45ef-804e-8007-b2c56a1698a4",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3388.230224609375L2554.761474609375,3373.23681640625L2576.996337890625,3358.23046875L2599.21923828125,3373.23681640625L2576.996337890625,3388.230224609375Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a1698a5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a1698a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3358.23046875L2576.996337890625,3387.584716796875",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-bcf98bd30c97-309ab5b4-45ef-804e-8007-b2c56a1698a5",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2576.996337890625,3358.23046875L2576.996337890625,3387.584716796875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#480b60",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-309ab5b4-45ef-804e-8007-b2c56a1698a6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-309ab5b4-45ef-804e-8007-b2c56a1698a6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2577.17236328125,3358.98681640625L2576.996337890625,3388.230224609375L2599.21923828125,3373.23681640625L2577.17236328125,3358.98681640625Z",
    style: {
      strokeWidth: 0,
      fill: "#480b60"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackegesIcon);
export default __webpack_public_path__ + "static/media/PackegesIcon.3aa2f9453aa4c623856d34a9ea31872b.svg";
export { ForwardRef as ReactComponent };